import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  loadingPatientSurgeries,
  loadedPatientSurgeries,
  failedPatientSurgeries,
  changeFilters,
} from "../../store/doctor/patientSurgerySlice";
import { translations } from "../../helpers";

export const usePatientSurgeryStore = () => {
  const dispatch = useDispatch();

  const { patientSurgeries, filters, pagination } = useSelector(
    (state) => state.doctor.patientSurgery
  );

  const getPatientSurgery = useCallback(
    async ({ filters, pagination }) => {
      try {
        dispatch(loadingPatientSurgeries());

        const filteredParams = Object.fromEntries(
          Object.entries({
            ...filters,
          }).filter(([_, value]) => value !== "")
        );

        const { totalPages, ...filteredPagination } = pagination;

        // console.log("filteredParams", filteredParams);

        const { data } = await gosafeApi.get("doctor/patientSurgery", {
          params: {
            ...filteredPagination,
            ...filteredParams,
          },
        });

        dispatch(loadedPatientSurgeries(data));

        return;
      } catch (error) {
        dispatch(
          failedPatientSurgeries(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch]
  );

  const getSearch = useCallback(
    async (filters) => {
      dispatch(changeFilters(filters));

      await getPatientSurgery({ filters, pagination });
    },
    [dispatch, pagination]
  );

  return {
    // Props
    patientSurgeries,
    filters,
    pagination,

    // Methods
    getPatientSurgery,
    getSearch,
  };
};
